import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useGlobal } from '../../state';

export const PageTitle = ({ title }) => (
  <Helmet>
    <title>{title ? `${title} - FetchFox` : 'FetchFox'}</title>
  </Helmet>
);

export const SummaryTitle = ({ summaryKey, object, fallback }) => {
  return <PageTitle title={fallback} />;

  const { sdk } = useGlobal();
  const [summary, setSummary] = useState();

  useEffect(() => {
    setSummary();
    if (!sdk || !summaryKey || !object) {
      return;
    }

    let cancelled = false;
    sdk
      .call('POST', '/api/summarize', { key: summaryKey, object })
      .then((value) => {
        if (!cancelled) {
          setSummary(value.summary);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [sdk, summaryKey, object]);

  return <PageTitle title={summary || fallback} />;
};
